import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { IEsimZoneForm } from "../../../interfaces/esim/EsimZone.types";
import InfoTip from "../../ui/InfoTip";
import Checkbox from "../../ui/input/Checkbox";
import Input from "../../ui/input/Input";

type Flag = "isRegional" | "highRisk" | "blockedForPurchase";

const FLAGS: { name: Flag; label: string; tip?: string }[] = [
  { name: "isRegional", label: "Zonë rajonale" },
  { name: "highRisk", label: "Rrezik i lartë", tip: "Pagesa me kartë kërkon 3-D Secure." },
  {
    name: "blockedForPurchase",
    label: "Blloko blerjen",
    tip: "Paketat nuk blihen; zona shfaqet me probleme teknike."
  }
];

interface Props {
  // Blocking purchases only makes sense on a zone that already sells.
  showBlocked: boolean;
}

// How the zone looks on the website and its flags; shared by creating, editing and importing a zone.
// The card colour and the list order are not asked (2026-10-16): a new zone gets the default colour
// and goes last in its list, and an edit keeps both as they are.
const ZoneStyleFields: FC<Props> = ({ showBlocked }) => {
  const {
    register,
    control,
    formState: { errors }
  } = useFormContext<IEsimZoneForm>();

  return (
    <>
      <Input {...register("imageUrl")} label="Foto (URL)" className="mb-4" error={errors.imageUrl?.message} />
      <Input
        {...register("coverImageUrl")}
        label="Foto e kopertinës (URL, opsionale)"
        className="mb-4"
        error={errors.coverImageUrl?.message}
      />
      {FLAGS.filter((f) => showBlocked || f.name !== "blockedForPurchase").map((flag) => (
        <Controller
          key={flag.name}
          control={control}
          name={flag.name}
          render={({ field: { value, onChange } }) => (
            // The tip sits outside the checkbox's label, so hovering it does not tick the box.
            <div className="flex items-center gap-2 mb-3">
              <Checkbox
                id={`zone-${flag.name}`}
                label={flag.label}
                checked={!!value}
                onChange={(e) => onChange(e.target.checked)}
              />
              {flag.tip && <InfoTip text={flag.tip} />}
            </div>
          )}
        />
      ))}
    </>
  );
};

export default ZoneStyleFields;
